import { render, staticRenderFns } from "./ValidationHistory.vue?vue&type=template&id=8061b110&scoped=true&lang=pug"
import script from "./ValidationHistory.vue?vue&type=script&lang=js"
export * from "./ValidationHistory.vue?vue&type=script&lang=js"
import style0 from "./ValidationHistory.vue?vue&type=style&index=0&id=8061b110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8061b110",
  null
  
)

export default component.exports